import { useAtomValue } from 'jotai';
import { selectors } from 'modules/common';
import { domain } from 'modules/data';
import { useSelector } from 'modules/react-redux';
import { useMemo } from 'react';
import { useNetSuiteVendorFieldSettings } from 'shared/hooks';
import { activeCompanyIdState } from 'shared/states';

export const useVendorTemplateFieldSettings = () => {
    const companyId = useAtomValue(activeCompanyIdState);

    const companyTemplates = useSelector((state) =>
        selectors.template.getIntegrationTemplatesByCompanyId(state, companyId)
    );

    const vendorTemplate = useMemo(() => {
        return companyTemplates.find((template) => template.integrationCode === domain.IntegrationCode.NetSuiteVendor);
    }, [companyTemplates]);

    const fieldSettings = useNetSuiteVendorFieldSettings(vendorTemplate?.documentFields);

    return fieldSettings;
};
